module.exports = __webpack_public_path__ + "assets/media/mac-desk.1f1c85b7.jpg";